import { DISPATCHER } from 'src/features/atoms/glove/japan/constants/actionType'
import { I18NText, PartialActionDispatch } from 'src/types'
import { webPartsObjs } from 'src/features/atoms/glove/constants/bases'
import { softTannerObjs } from '../constants/colors'
import { objectsFilter } from 'src/logic'

// TODO: ロジックと I/O を分離する→ 引数にdispatchを渡すのをやめる
// あとhooksは利用していないので、useXXXという命名はやめる
export const useDispatcher = (key: string, dispatch: PartialActionDispatch, t: I18NText): ((key: string) => void) => {
  const dispatchBaseStore = {
    tanner: { objects: [...t.TANNER_OBJECTS, ...softTannerObjs], actionType: DISPATCHER['tanner'] },
    dominantArm: { objects: t.DOMINANT_ARM_OBJECTS, actionType: DISPATCHER['dominantArm'] },
    backStyle: { objects: t.BACK_STYLE_OBJECTS, actionType: DISPATCHER['backStyle'] },
    size: { objects: t.SIZE_OBJECTS, actionType: DISPATCHER['size'] },
    backLace: { objects: t.BACK_LACE_OBJECTS, actionType: DISPATCHER['backLace'] },
    fingerGuardType: {
      objects: t.FINGER_GUARD_TYPE_ALL_OBJECTS,
      actionType: DISPATCHER['fingerGuardType']
    },
    materialPack: { objects: t.MATERIAL_PACK_OBJECTS, actionType: DISPATCHER['materialPack'] },
    webParts: { objects: webPartsObjs, actionType: DISPATCHER['webParts'] },
    printLeatherType: { objects: t.PRINT_LEATHER_TYPE_OBJECTS, actionType: DISPATCHER['printLeatherType'] },
    edge: { objects: t.EDGE_COLOR_OBJECTS, actionType: DISPATCHER['edge'] },
    lace: { objects: t.LACE_COLOR_OBJECTS, actionType: DISPATCHER['lace'] },
    stitch: { objects: t.STITCH_COLOR_OBJECTS, actionType: DISPATCHER['stitch'] },
    hamidashi: { objects: t.HAMIDASHI_COLOR_ALL_OBJECTS, actionType: DISPATCHER['hamidashi'] },
    mouton: { objects: t.MOUTON_COLOR_OBJECTS, actionType: DISPATCHER['mouton'] },
    atomsLabel: { objects: t.LABEL_COLOR_OBJECTS, actionType: DISPATCHER['atomsLabel'] },
    moldingOrder: { objects: t.MOLDING_OBJECTS, actionType: DISPATCHER['moldingOrder'] },
    loopOfRingFinger: { objects: t.LOOP_OF_RING_FINGER_OBJECTS, actionType: DISPATCHER['loopOfRingFinger'] }
  }
  const item = dispatchBaseStore[key]
  return (selected: string) => {
    dispatch({
      type: item.actionType,
      [key]: objectsFilter(selected, item.objects)
    })
  }
}
